import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

import {
  sortNumeric,
  selectFormat,
  TableContentCell,
  Error,
  getMetricForColumn,
} from "./../../Utils/Utils.js";

class SeasonReleasePopularity extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
    this.props.passRefUpward(this.childRef);
  }

  renderTable(data) {
    const { cells, title, url } = this.props;

    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "320px", minWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        formatExtraData: {
          name: url.split("/")[2],
        },
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
        sort: true,
      },
      {
        dataField: "release_date",
        text: "Release Date",
        style: { width: "100px", minWidth: "100px" },
        csvFormatter: (cell) => cell,
        sort: true,
      },
      {
        dataField: "shares_30_days",
        text: "Shares/30days",
        style: { width: "110px", minWidth: "110px" },
        formatter: (cell) => selectFormat("number", cell && cell.value, "0.0%"),
        csvFormatter: (cell) =>
          selectFormat("number", cell && cell.value, "0.0%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "shares_60_days",
        text: "Shares/60days",
        style: { width: "110px", minWidth: "110px" },
        formatter: (cell) => selectFormat("number", cell && cell.value, "0.0%"),
        csvFormatter: (cell) =>
          selectFormat("number", cell && cell.value, "0.0%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views_30_sec_unique_30_days",
        text: "30s / 30 Days",
        style: { width: "110px", minWidth: "110px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views_30_sec_unique_60_days",
        text: "30s / 60 Days",
        style: { width: "110px", minWidth: "110px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views_30_sec_unique_90_days",
        text: "30s / 90 Days",
        style: { width: "110px", minWidth: "110px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views_30_sec_unique_120_days",
        text: "30s / 120 Days",
        style: { width: "110px", minWidth: "110px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views_30_sec_unique_year",
        text: "30s / Year",
        style: { width: "90px", minWidth: "90px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views_30_sec_unique_lifetime",
        text: "30s / Lifetime",
        style: { width: "110px", minWidth: "110px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const pagination = paginationFactory({
      sizePerPage: 15,
      hideSizePerPage: true,
    });

    const defaultSorted = [
      {
        dataField: "release_date",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            pagination={pagination}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default SeasonReleasePopularity;
